// Public visitor-widget endpoints (no ChatBizz login: a website visitor is anonymous).
import { apiClient } from "../apiClient";

const send = (url, body) => apiClient(url, { method: "POST", body: JSON.stringify(body || {}) }).then((res) => res.data);

export const getWidgetBot = (botId) => apiClient(`/api/widget/bot${botId ? `?botId=${encodeURIComponent(botId)}` : ""}`).then((res) => res.data);
/** -> { conversationId, bot, conversation, suggestedQuestions } */
export const startConversation = (payload = {}) => send("/api/widget/start", payload);
export const getVisitorConversation = (conversationId) => apiClient(`/api/widget/${conversationId}`).then((res) => res.data);
export const sendVisitorMessage = (conversationId, message) => send(`/api/widget/${conversationId}/messages`, { message });
/** -> { lead, duplicate, conversation } */
export const captureLead = (conversationId, details) => send(`/api/widget/${conversationId}/lead`, details);
